// mobile/sections.js — mobile site (ported from website2m-sections.jsx): the "Follow one
// visit" journey and the founding-shop pricing card stacked for a phone. N3Journey is the
// scroll-driven stage — a runway pins a screen-high stage; vertical scroll slides the
// chapters left → right and scrubs each scene's story beats (via the N2Scrub store).
// Scenes reuse the real ones from ../features.js; FAQ / final / footer reuse ../sections.js.
// NOTE: this app scrolls on <body> (see index.css), so every scroll read/write targets it.
import React from 'react'
import { N2Ic, NIc, N2Paw } from '../icons'
import { N2Btn, N2Sticker, N2Toast, N2Scrub, useN2Phases } from '../shell'
import { trackGetStartedClick } from '../track'
import { N2SectionHead } from '../sections'
import { N2F_LP_THEMES, N2F_LP_PHOTOS, N2fPhone, N2fAgreements, N2fCheckout } from '../features'
import { MsTap } from './screens'
import namiLogo from '../../../assets/nami-logo.png'

/* ── chapter 01, mobile cut: the merchant's own mobile landing page on a phone —
   themes cycle, then Harper taps Book and the request lands in the shop's inbox ── */
function N3fLanding({ on }) {
	const phase = useN2Phases(on, [[1100, 't1'], [2100, 't2'], [3100, 't0'], [4000, 'tap'], [4700, 'press'], [5200, 'toast']])
	const [pick, setPick] = React.useState(null)
	const P = ['idle', 't1', 't2', 't0', 'tap', 'press', 'toast']
	const at = (p) => P.indexOf(phase) >= P.indexOf(p)
	const ti = pick != null ? pick : phase === 't1' ? 1 : phase === 't2' ? 2 : 0
	const th = N2F_LP_THEMES[ti]
	return (
		<div className="n3f-sc1">
			<div className="n2f-sw">
				Make it yours
				{N2F_LP_THEMES.map((t, i) => (
					<i key={t.id} className={i === ti ? 'on' : ''} style={{ background: t.acc }} role="button" tabIndex={0}
						aria-label={'Preview the ' + t.id + ' theme'} title={t.id}
						onClick={() => setPick(i)}
						onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setPick(i) } }}></i>
				))}
			</div>
			<div className="n2f-phone">
				<div className="n2f-ph-scr n3f-lp" style={{ '--lpa': th.acc, '--lpd': th.deep, '--lpt': th.tint }}>
					<div className="n3f-lp-url"><N2Ic name="globe" size={9} sw={2} />namigrooming.nami.pet</div>
					<div className="n3f-lp-top">
						<img src={namiLogo} alt="" />
						<strong>Nami Grooming</strong>
						<span className="n3f-lp-burger"><i></i><i></i><i></i></span>
					</div>
					<div className="n3f-lp-body">
						<div className="n3f-lp-hero">
							<img src={N2F_LP_PHOTOS[0]} alt="" loading="lazy" />
							<span className="n3f-lp-all"><N2Ic name="grid" size={9} sw={2.2} />All photos</span>
							<span className="n3f-lp-dots"><i className="on"></i><i></i><i></i></span>
						</div>
						<div className="n3f-lp-id">
							<img src={namiLogo} alt="" />
							<div><h4>Nami Grooming</h4><span className="n3f-lp-st"><i></i>Open now <em>· until 5:00 PM</em></span></div>
							<span className="n3f-lp-call"><NIc name="phone" size={11} sw={1.8} /></span>
						</div>
						<div className="n3f-lp-svc">
							<span className="n3f-lp-kick"><N2Paw size={8} />Menu &amp; pricing</span>
							<div className="n3f-lp-h2">Services <em>&amp; pricing</em></div>
							<div className="n3f-lp-tabs"><span className="on">Services</span><span>Add-ons</span></div>
							<div className="n3f-lp-row open">
								<div className="n3f-lp-rh"><span className="no">01</span><span className="t"><strong>Full Grooms</strong><small><b>from $80</b> · 4 options</small></span><span className="x"><N2Ic name="plus" size={9} sw={2.6} /></span></div>
								<div className="n3f-lp-it"><span className="t"><strong>Full Groom — Small</strong><small>Up to 25 lbs.</small></span><span className="m"><strong>$80</strong><small>50 min</small></span></div>
								<div className="n3f-lp-it"><span className="t"><strong>Full Groom — Medium</strong><small>25–50 lbs.</small></span><span className="m"><strong>$95</strong><small>60 min</small></span></div>
							</div>
							<div className="n3f-lp-row">
								<div className="n3f-lp-rh"><span className="no">02</span><span className="t"><strong>Baths &amp; Tidy</strong><small><b>from $18</b> · 3 options</small></span><span className="x"><N2Ic name="plus" size={9} sw={2.6} /></span></div>
							</div>
						</div>
					</div>
					<div className="n3f-lp-bar">
						<span className={'n3f-lp-book' + (phase === 'press' ? ' pressed' : '')}>Book an appointment<MsTap show={phase === 'tap' || phase === 'press'} press={phase === 'press'} x="50%" y="50%" /></span>
					</div>
				</div>
			</div>
			<div className={'n2f-poptoast' + (at('toast') ? ' show' : '')}>
				<N2Toast ic="mint" icon="globe" title="New request — Waffles" sub="Full Groom — Medium · Sat 10:00 AM" />
			</div>
		</div>
	)
}

/* ── chapter 02, mobile cut: the three-reminder schedule sits over Harper's phone; each reminder fires in turn ── */
const N3F_RM = [
	{ k: '7d', lbl: '7 days', stamp: 'Sat, Jul 18 · 9:00 AM', msg: 'Hi Harper! Waffles’ Full Groom with Ashley is set for Sat, Jul 25 at 10:00 AM.' },
	{ k: '1d', lbl: '1 day', stamp: 'Fri, Jul 24 · 10:00 AM', msg: 'Waffles’ groom is tomorrow at 10:00 AM. See you soon!' },
	{ k: '2h', lbl: '2 hours', stamp: 'Sat, Jul 25 · 8:00 AM', msg: 'Waffles’ groom is in 2 hours — see you at 10:00!' }
]
function N3fReminders({ on }) {
	const phase = useN2Phases(on, [[1200, 'r1'], [2500, 'r2'], [3800, 'r3'], [4800, 'typing'], [5600, 'reply']])
	const P = ['idle', 'r1', 'r2', 'r3', 'typing', 'reply']
	const at = (p) => P.indexOf(phase) >= P.indexOf(p)
	const fired = ['r1', 'r2', 'r3'].filter((p) => at(p)).length
	const state = (i) => (at('typing') ? 'done' : i < fired - 1 ? 'done' : i === fired - 1 ? 'live' : 'todo')
	const prog = at('typing') ? 1 : Math.max(0, fired - 1) / 3
	return (
		<div className="n3f-sc2">
			<div className="n3f-rm">
				<div className="n3f-rm-head"><span className="t">Reminders</span><span className="pill"><N2Ic name="check" size={11} sw={2.8} />3 of 3 on</span></div>
				<div className="n3f-rail" style={{ '--p': prog }} aria-hidden="true">
					<i className="n3f-line"></i><i className="n3f-line fill"></i>
					{N3F_RM.map((r, i) => (
						<span className={'n3f-node ' + state(i)} key={r.k}>
							<i>{state(i) === 'done' ? <N2Ic name="check" size={11} sw={3} /> : i + 1}</i>
							<b>{r.lbl}</b><small>before</small>
						</span>
					))}
					<span className={'n3f-node end' + (at('typing') ? ' live' : '')}><i><NIc name="calendar" size={12} sw={1.8} /></i><b>Visit</b><small>Sat 10 AM</small></span>
				</div>
			</div>
			<N2fPhone name="Harper Quinn" ava="HQ">
				{N3F_RM.map((r, i) => (
					<React.Fragment key={r.k}>
						<span className={'n3f-stamp' + (at('r' + (i + 1)) ? ' show' : '')}>{r.stamp}</span>
						<div className={'n2f-bub out' + (at('r' + (i + 1)) ? ' show' : '')}>{r.msg}</div>
					</React.Fragment>
				))}
				{phase === 'typing' ? <span className="n2f-typing" aria-hidden="true"><i></i><i></i><i></i></span> : null}
				<div className={'n2f-bub' + (at('reply') ? ' show' : '')}>Thanks! On our way soon.</div>
			</N2fPhone>
		</div>
	)
}

const N3_STEPS = [
	{ id: 'landing', kick: '01 · Booked', crumb: 'Booked',
		h: <React.Fragment>Your <em>landing page</em></React.Fragment>,
		sub: 'Never lose a booking. 24/7 reception.',
		fact: 'Tue 9:12 PM — Harper books Waffles’ first groom',
		scene: (on) => <N3fLanding on={on} /> },
	{ id: 'reminders', kick: '02 · Reminded', crumb: 'Reminded',
		h: <React.Fragment>Automated <em>reminders</em></React.Fragment>,
		sub: '85% fewer no-shows. Zero phone calls.',
		fact: 'Sat 8:00 AM — third reminder out · no-show prevented',
		scene: (on) => <N3fReminders on={on} /> },
	{ id: 'agreements', kick: '03 · Signed', crumb: 'Signed',
		h: <React.Fragment>Digital <em>agreements</em></React.Fragment>,
		sub: 'Signed before drop-off. Proof when it matters.',
		fact: 'Sat 8:41 AM — both forms signed before drop-off',
		scene: (on) => <N2fAgreements on={on} /> },
	{ id: 'square', kick: '04 · Paid', crumb: 'Paid',
		h: <React.Fragment>Checkout, <em>Square built in</em></React.Fragment>,
		sub: 'Goodbye takes ten seconds.',
		fact: 'Sat 11:04 AM — $145.08 paid · tipped · receipted',
		scene: (on) => <N2fCheckout on={on} /> }
]

/* scales a fixed-width composition (w px) to fit its box on both axes, centered */
function N3FitBox({ w = 340, children }) {
	const box = React.useRef(null), inner = React.useRef(null)
	React.useEffect(() => {
		const b = box.current, el = inner.current
		if (!b || !el) return
		const fit = () => { const s = Math.min(1.1, b.clientWidth / w, b.clientHeight / Math.max(1, el.offsetHeight)); el.style.transform = 'translate(-50%, -50%) scale(' + s.toFixed(4) + ')' }
		const ro = new ResizeObserver(fit)
		ro.observe(b); ro.observe(el); fit()
		return () => ro.disconnect()
	}, [w])
	return <div className="n3-fit" ref={box}><div className="n3-fit-in" ref={inner} style={{ width: w }}>{children}</div></div>
}

/* ── the journey, scroll-driven ──────────────────────────────────────────────
   A tall runway pins a stage the height of the screen, and vertical scroll is the only clock.
   Each chapter owns an equal slice of the runway: parked for the first 64% (the scene's story
   beats scrub with the thumb, and rewind), then the filmstrip slides one card left → right for
   the rest. The rail's ink lens glides continuously with the strip, and the visit log under
   the strip stamps each chapter's timestamp. */
const N3_PARK = 0.64                  // parked share of a chapter's runway
const N3_SLIDE = 1100                 // ms the self-driving stage spends sliding to the next chapter
const N3_LEAD = [0, 900, 3300, 400]   // ms into each scene's timeline where the phone-only mobile cut first moves
const N3_DWELL = [7000, 7200, 8200, 7600]
const N3_SCENE_W = [254, 254, 250, 300]
const n3Smooth = (x) => { x = Math.min(1, Math.max(0, x)); return x * x * (3 - 2 * x) }
function n3Store(lead) {
	const subs = new Set(); let q = 0
	return { lead, get: () => q, set: (v) => { if (v !== q) { q = v; subs.forEach((f) => f(v)) } }, subscribe: (f) => { subs.add(f); return () => subs.delete(f) } }
}
export function N3Journey({ len = 120 }) {
	const n = N3_STEPS.length
	const reduce = React.useRef(window.matchMedia('(prefers-reduced-motion: reduce)').matches).current
	const runRef = React.useRef(null), stageRef = React.useRef(null), railRef = React.useRef(null), stripRef = React.useRef(null), cards = React.useRef([])
	const stores = React.useRef(N3_LEAD.map((l) => n3Store(l))).current
	const [active, setActive] = React.useState(0)
	const [started, setStarted] = React.useState(false)
	const [near, setNear] = React.useState(false)
	const activeRef = React.useRef(0)

	const measure = React.useCallback(() => {
		const run = runRef.current, stage = stageRef.current, nav = document.querySelector('.n3-nav')
		const r = run.getBoundingClientRect(), navTop = (nav && nav.offsetHeight) || 60
		return { r, navTop, range: Math.max(1, r.height - stage.offsetHeight) }
	}, [])
	// jump the page to a chapter's parked start; the stage animates along the way
	const go = React.useCallback((k) => {
		if (!runRef.current) return
		k = Math.max(0, Math.min(n - 1, k))
		const { r, navTop, range } = measure()
		const sc = document.body // the app's scroll container
		sc.scrollTo({ top: sc.scrollTop + r.top - navTop + (k + 0.04) * range / n, behavior: reduce ? 'auto' : 'smooth' })
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [measure, n])

	React.useEffect(() => {
		const run = runRef.current, stage = stageRef.current, rail = railRef.current
		if (!run || !stage || !rail) return
		let raf = 0
		const frame = () => {
			raf = 0
			const { r, navTop, range } = measure()
			const p = Math.min(1, Math.max(0, (navTop - r.top) / range))
			const u = Math.min(n - 1e-6, p * n), i = Math.floor(u), t = u - i
			const s = i === n - 1 ? i : i + n3Smooth((t - N3_PARK) / (1 - N3_PARK))
			const park = Math.min(1, t / (i === n - 1 ? 0.86 : N3_PARK))
			stores.forEach((st, k) => st.set(k < i ? 1 : k > i ? 0 : park))
			cards.current.forEach((el, k) => {
				if (!el) return
				const d = k - s
				el.style.setProperty('--d', d.toFixed(4))
				el.style.setProperty('--ad', Math.min(1, Math.abs(d)).toFixed(4))
				el.style.visibility = Math.abs(d) > 1.15 ? 'hidden' : 'visible'
				stage.style.setProperty('--g' + k, Math.max(0, 1 - Math.abs(d)).toFixed(3)) // that chapter's ambient light
			})
			rail.style.setProperty('--s', s.toFixed(4))
			rail.style.setProperty('--q', park.toFixed(4))
			stage.style.setProperty('--jd', '0')
			const a = Math.round(s)
			if (a !== activeRef.current) { activeRef.current = a; setActive(a) }
			setStarted(p > 0.015)
		}
		const kick = () => { if (!raf) raf = requestAnimationFrame(frame) }
		// capture phase: the app scrolls on <body>, not the window
		window.addEventListener('scroll', kick, { capture: true, passive: true })
		window.addEventListener('resize', kick)
		const ro = new ResizeObserver(kick)
		ro.observe(stage)
		const io = new IntersectionObserver((es) => { setNear(es[0].isIntersecting); kick() }, { rootMargin: '25% 0px' })
		io.observe(run)
		kick()
		return () => { window.removeEventListener('scroll', kick, { capture: true }); window.removeEventListener('resize', kick); ro.disconnect(); io.disconnect(); if (raf) cancelAnimationFrame(raf) }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	// self-driving: while the stage is pinned and the reader's hands are off, the page glides along the
	// runway by itself at the scenes' own pace (N3_DWELL parked, N3_SLIDE sliding) — scroll is still the only
	// clock, so any touch, wheel, or key fast-forwards (or rewinds) and pauses the drive until the reader is idle
	React.useEffect(() => {
		if (reduce) return
		const sc = document.body // the app's scroll container
		let raf = 0, last = 0, idleAt = 0, expY = null, virtY = 0, down = false
		const user = () => { idleAt = performance.now() + 120; expY = null } // just long enough to let a fling settle
		const onScroll = () => { if (expY == null || Math.abs(sc.scrollTop - expY) > 1.5) user() }
		const onDown = () => { down = true; user() }
		const onUp = () => { down = false; user() }
		const tick = (now) => {
			raf = requestAnimationFrame(tick)
			const dt = Math.min(50, now - (last || now)); last = now
			if (down || now < idleAt || document.hidden || !runRef.current) return
			const { r, navTop, range } = measure()
			const p = (navTop - r.top) / range
			if (p < -0.001 || p >= 1) { expY = null; return }
			if (expY == null || Math.abs(sc.scrollTop - virtY) > 1.5) virtY = sc.scrollTop
			const u = Math.min(n - 1e-6, Math.max(0, p) * n), i = Math.floor(u), t = u - i
			const rate = i === n - 1 ? 0.86 / N3_DWELL[i] : t < N3_PARK ? N3_PARK / N3_DWELL[i] : (1 - N3_PARK) / N3_SLIDE // chapters per ms
			virtY += rate * dt * range / n
			sc.scrollTo({ top: virtY, behavior: 'instant' })
			expY = sc.scrollTop
		}
		window.addEventListener('scroll', onScroll, { capture: true, passive: true })
		window.addEventListener('wheel', user, { passive: true })
		window.addEventListener('keydown', user)
		window.addEventListener('pointerdown', user)
		window.addEventListener('touchstart', onDown, { passive: true })
		window.addEventListener('touchend', onUp)
		window.addEventListener('touchcancel', onUp)
		raf = requestAnimationFrame(tick)
		return () => { cancelAnimationFrame(raf); window.removeEventListener('scroll', onScroll, { capture: true }); window.removeEventListener('wheel', user); window.removeEventListener('keydown', user); window.removeEventListener('pointerdown', user); window.removeEventListener('touchstart', onDown); window.removeEventListener('touchend', onUp); window.removeEventListener('touchcancel', onUp) }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	// a horizontal swipe on the strip jumps a chapter — by scrolling the page, so the stage still moves with scroll
	React.useEffect(() => {
		const el = stripRef.current
		if (!el) return
		let x0 = 0, y0 = 0, live = false
		const ts = (e) => { live = true; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY }
		const te = (e) => {
			if (!live) return
			live = false
			const dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0
			if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) go(activeRef.current + (dx < 0 ? 1 : -1))
		}
		el.addEventListener('touchstart', ts, { passive: true })
		el.addEventListener('touchend', te)
		return () => { el.removeEventListener('touchstart', ts); el.removeEventListener('touchend', te) }
	}, [go])

	const step = N3_STEPS[active], dash = step.fact.indexOf(' — ')
	const when = dash > 0 ? step.fact.slice(0, dash) : '', what = dash > 0 ? step.fact.slice(dash + 3) : step.fact
	return (
		<section className="n3-jn" id="features">
			<div className="n3-shore" aria-hidden="true">
				<svg viewBox="0 0 390 140" preserveAspectRatio="none">
					<defs>
						<linearGradient id="n3sea" x1="0" y1="0" x2="0" y2="1">
							<stop offset="0" stopColor="#7C6BD9" stopOpacity="0"></stop>
							<stop offset="0.6" stopColor="#7C6BD9" stopOpacity="0.13"></stop>
							<stop offset="1" stopColor="#8B7DDE" stopOpacity="0.19"></stop>
						</linearGradient>
						<linearGradient id="n3sea2" x1="0" y1="0" x2="0" y2="1">
							<stop offset="0" stopColor="#8B7DDE" stopOpacity="0"></stop>
							<stop offset="1" stopColor="#8B7DDE" stopOpacity="0.075"></stop>
						</linearGradient>
						<filter id="n3foam" x="-20%" y="-300%" width="140%" height="700%"><feGaussianBlur stdDeviation="1.2"></feGaussianBlur></filter>
					</defs>
					<g className="n2f-w2">
						<path d="M0 -60 L0 90 q 40 6 80 3 q 36 -7 76 -4 q 38 7 80 4 q 36 -7 78 -3 q 34 5 76 0 L390 -60 Z" fill="url(#n3sea2)"></path>
						<path d="M0 90 q 40 6 80 3 q 36 -7 76 -4 q 38 7 80 4 q 36 -7 78 -3 q 34 5 76 0" fill="none" stroke="#FFFFFF" strokeWidth="1.2" opacity="0.5" vectorEffect="non-scaling-stroke"></path>
					</g>
					<g className="n2f-w1">
						<path d="M0 -60 L0 56 q 32 8 66 4 q 30 -10 64 -6 q 28 10 62 6 q 34 -11 68 -4 q 28 8 64 2 q 30 -8 66 -4 L390 -60 Z" fill="url(#n3sea)"></path>
						<path className="n2f-foamwide" d="M0 56 q 32 8 66 4 q 30 -10 64 -6 q 28 10 62 6 q 34 -11 68 -4 q 28 8 64 2 q 30 -8 66 -4" fill="none" stroke="#FFFFFF" strokeWidth="4" opacity="0.4" filter="url(#n3foam)" vectorEffect="non-scaling-stroke"></path>
						<path d="M0 56 q 32 8 66 4 q 30 -10 64 -6 q 28 10 62 6 q 34 -11 68 -4 q 28 8 64 2 q 30 -8 66 -4" fill="none" stroke="#FFFFFF" strokeWidth="1.6" opacity="0.92" vectorEffect="non-scaling-stroke"></path>
					</g>
				</svg>
				<div className="n3-sandtrail">
					{Array.from({ length: 10 }, (_, i) => (
						<span key={i} style={{ '--i': i, left: (4 + i * 9.6) + '%', bottom: (i % 2 ? 22 : 12) + 'px', transform: 'rotate(' + (i % 2 ? 98 : 82) + 'deg)' }}><N2Paw size={11} /></span>
					))}
				</div>
			</div>
			<div className="n3-jn-head">
				<N2SectionHead eyebrow="Follow one visit" title={<React.Fragment>Watch a visit run <em>itself.</em></React.Fragment>}
					sub="Waffles the Goldendoodle, booked to paid — Nami handles every step." />
			</div>
			<div className="n3-jrun" ref={runRef} style={{ '--n': n, '--jl': len }}>
				<div className="n3-jstage" ref={stageRef}>
					<div className="n3-jglow" aria-hidden="true"><i></i><i></i><i></i><i></i></div>
					<div className="n3-jsrail" ref={railRef} role="tablist" aria-label="Chapters" style={{ '--n': n }}>
						<i className="n3-jsrail-lens" aria-hidden="true"><i className="n3-jsrail-fill"></i></i>
						<div className="n3-jsrail-row">
							{N3_STEPS.map((s, i) => (
								<button key={s.id} type="button" role="tab" aria-selected={active === i} className="n3-jsseg" onClick={() => go(i)}>
									<em>0{i + 1}</em><span>{s.crumb}</span>
								</button>
							))}
						</div>
						<div className="n3-jsrail-row inv" aria-hidden="true">
							{N3_STEPS.map((s, i) => <span key={s.id} className="n3-jsseg"><em>0{i + 1}</em><span>{s.crumb}</span></span>)}
						</div>
					</div>
					<div className="n3-jstrip" ref={stripRef}>
						{N3_STEPS.map((s, i) => {
							const on = near && active === i
							return (
								<article key={s.id} ref={(el) => { cards.current[i] = el }} className={'n3-jsc c' + i + (on ? ' on' : '')} aria-hidden={active !== i}>
									<header className="n3-jsc-h">
										<h3>{s.h}</h3>
										<p>{s.sub}</p>
									</header>
									<div className="n3-jsc-scene">
										<N2Scrub.Provider value={stores[i]}>
											<N3FitBox w={N3_SCENE_W[i]}><div className="n3-scene">{s.scene(on)}</div></N3FitBox>
										</N2Scrub.Provider>
									</div>
								</article>
							)
						})}
					</div>
					<div className="n3-jsfact" aria-live="polite">
						{started ? (
							<div className="n3-jsfact-in" key={'f' + active}><i className="n3-jsdot" aria-hidden="true"></i><b>{when}</b><span>{what}</span></div>
						) : (
							<div className="n3-jsfact-in cue" key="cue"><span className="n3-jscue" aria-hidden="true"><N2Ic name="chevron" size={15} sw={2.4} /></span><span>Scroll to follow Waffles’ visit</span></div>
						)}
					</div>
				</div>
			</div>
		</section>
	)
}

/* ── pricing — one-screen membership card: price + CTA, compact "everything included" grid, perks ── */
const N3_PC_FEATURES = [
	{ t: 'Unlimited appointments' },
	{ t: 'Online booking page' },
	{ t: 'Two-way client texting' },
	{ t: 'Texts that book themselves', ai: true },
	{ t: 'Automated reminders' },
	{ t: 'Square checkout & tips' },
	{ t: 'Digital agreements' },
	{ t: 'Staff management' },
	{ t: 'Dashboard & reports' },
	{ t: 'Client & pet profiles' }
]
const N3_PC_PERKS = [
	{ icon: 'heart', tone: 'blush', t: 'Perks for life', s: 'Founding benefits stay yours' },
	{ icon: 'users', tone: 'lav', t: 'Free move‑in', s: 'We migrate your clients & pets' },
	{ icon: 'chat', tone: 'mint', t: 'Direct line', s: 'Talk to the people building it' }
]
export function N3Pricing({ cta }) {
	return (
		<section className="n2-section" id="pricing">
			<div className="n2-wrap">
				<N2SectionHead eyebrow="Pricing" title={<React.Fragment>Every feature. <em>Zero dollars.</em></React.Fragment>}
					sub="Free for early grooming shops. The whole product, no limits, no card." />
				<div className="n3-pricewrap n2-reveal">
					<i className="n2-price-halo" aria-hidden="true"></i>
					<div className="n3-pc">
						<div className="n3-pc-top">
							<span className="n3-pc-paw" aria-hidden="true"><N2Paw size={150} /></span>
							<div className="n3-pc-badges"><N2Sticker blush icon="heart" style={{ position: 'static', display: 'inline-flex' }}>Founding shop offer</N2Sticker></div>
							<div className="n3-pc-price">
								<strong className="n3-pc-num">$0</strong>
								<div className="n3-pc-per"><b>/ month</b><s>Usually $60–$130 / mo</s></div>
							</div>
							<N2Btn to="/login" className="n2-price-cta" onClick={trackGetStartedClick('mobile_pricing', cta)}>{cta}</N2Btn>
						</div>
						<div className="n3-pc-body">
							<div className="n3-pc-lhead"><span>Everything included</span></div>
							<ul className="n3-pc-grid">{N3_PC_FEATURES.map((f) => (
								<li key={f.t}>
									<span className={'n2-pl-ic' + (f.ai ? ' ai' : '')}><N2Ic name={f.ai ? 'spark' : 'check'} size={11} sw={2.8} /></span>
									<b>{f.t}</b>
								</li>
							))}</ul>
							<span className="n3-pc-plabel">Founding shop perks</span>
							<div className="n3-pc-perks">{N3_PC_PERKS.map((p) => (
								<div className="n3-pc-perk" key={p.t}>
									<span className={'n2-perk-ic ' + p.tone}><N2Ic name={p.icon} size={15} sw={2} /></span>
									<b>{p.t}</b>
									<span>{p.s}</span>
								</div>
							))}</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
